module.exports = __webpack_public_path__ + "img/2.22b125e6.jpeg";